import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TransportDetail } from '../../gantt-chart.model';

@Component({
    selector: 'app-transport-row',
    templateUrl: './transport-row.component.html',
    styleUrls: ['./transport-row.component.scss'],
    standalone: false
})
export class TransportRowComponent implements OnInit {

  @Input() transports: Array<TransportDetail>;

  @Input() selectedTransportId: number;

  @Input() scale: number;

  @Input() offsetBefore: number;

  @Output() selectedTransport = new EventEmitter<number>();

  constructor() { }

  ngOnInit(): void {
  }

  selectTransport(transportId: number) {
    this.selectedTransport.emit(transportId);
  }

}
